import WhereToGoSelect from './WhereToGoSelect'

export default WhereToGoSelect
